/* CiepLovo · Dyfuzor Kominek */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var K = window.kominek || {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var v = (c / 100).toFixed(2).replace('.', ',');
    return (K.moneyFormat || '{{amount_with_comma_separator}} zł').replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  var toastT;
  function toast(msg) {
    var t = $('#KToast'); if (!t) return;
    t.innerHTML = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 3800);
  }
  window.kToast = toast;

  /* ---------- 1. Płomienna kurtyna między stronami ---------- */
  var cur = $('#KCurtain');
  function curtainOut() {
    if (!cur) return;
    cur.classList.remove('is-in'); cur.classList.add('is-out'); cur.classList.remove('is-on');
    setTimeout(function () { cur.classList.remove('is-out'); }, 950);
  }
  if (cur) {
    if (RM) { cur.classList.remove('is-on'); }
    else if (document.readyState === 'complete') curtainOut();
    else { window.addEventListener('load', curtainOut); setTimeout(curtainOut, 1600); }
    window.addEventListener('pageshow', function (e) { if (e.persisted) { cur.className = 'k-curtain'; } });
    document.addEventListener('click', function (e) {
      if (RM || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-curtain')) return;
      var url; try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      if (/^\/(checkout|cart\/|account\/logout)/.test(url.pathname)) return;
      e.preventDefault();
      cur.classList.remove('is-out'); cur.classList.add('is-in');
      setTimeout(function () { location.href = url.href; }, 520);
    });
  }

  /* ---------- 2. Żar – unoszące się iskry ---------- */
  var cv = $('#KEmbers');
  if (cv && !RM) {
    var ctx = cv.getContext('2d'), W = 0, H = 0, DPR = Math.min(2, window.devicePixelRatio || 1), parts = [], boost = 0, lastY = window.scrollY;
    var N = window.innerWidth < 700 ? 28 : 55;
    function size() { W = cv.width = innerWidth * DPR; H = cv.height = innerHeight * DPR; cv.style.width = innerWidth + 'px'; cv.style.height = innerHeight + 'px'; }
    function spawn(p, init) {
      p.x = Math.random() * W; p.y = init ? Math.random() * H : H + 20 * DPR;
      p.r = (Math.random() * 1.8 + .6) * DPR; p.vy = (Math.random() * .6 + .35) * DPR; p.vx = (Math.random() - .5) * .3 * DPR;
      p.life = 0; p.max = 260 + Math.random() * 380; p.ph = Math.random() * 6.28; p.h = 20 + Math.random() * 25;
      return p;
    }
    size(); for (var i = 0; i < N; i++) parts.push(spawn({}, true));
    addEventListener('resize', size);
    addEventListener('scroll', function () { var y = window.scrollY; boost = Math.min(6, boost + Math.abs(y - lastY) * .02); lastY = y; }, { passive: true });
    (function tick() {
      ctx.clearRect(0, 0, W, H);
      boost *= .94;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i]; p.life++;
        p.ph += .03; p.x += p.vx + Math.sin(p.ph) * .35 * DPR; p.y -= p.vy * (1 + boost);
        var k = p.life / p.max, a = k < .1 ? k * 10 : 1 - (k - .1) / .9;
        if (p.y < -20 || p.life > p.max) { spawn(p); continue; }
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
        g.addColorStop(0, 'hsla(' + (p.h + 15) + ',100%,75%,' + (.9 * a) + ')');
        g.addColorStop(.4, 'hsla(' + p.h + ',100%,55%,' + (.45 * a) + ')');
        g.addColorStop(1, 'hsla(' + p.h + ',100%,50%,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 4, 0, 6.283); ctx.fill();
      }
      requestAnimationFrame(tick);
    })();
  }

  /* ---------- 3. Rozpalanie elementów przy przewijaniu ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
    ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-lit'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .12 }) : null;
  $$('[data-ignite], .k-firedivider').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-lit'); });

  /* ---------- 4. Nagłówek, kursor ---------- */
  var hdr = $('.k-header');
  function onScroll() { if (hdr) hdr.classList.toggle('is-scrolled', window.scrollY > 10); }
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
  var gc = $('.k-glow-cursor');
  if (gc && matchMedia('(hover:hover) and (pointer:fine)').matches && !RM) {
    addEventListener('pointermove', function (e) { gc.classList.add('is-on'); gc.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)'; }, { passive: true });
  }

  /* ---------- 5. Autoodtwarzanie wideo tylko w kadrze ---------- */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
    ents.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); p && p.catch && p.catch(function () {}); } else v.pause(); });
  }, { threshold: .15 }) : null;
  $$('video[data-auto]').forEach(function (v) { v.muted = true; v.playsInline = true; vio ? vio.observe(v) : v.play(); });

  /* ---------- 6. Napisy zsynchronizowane z filmem (sekcja TV vs kominek) ---------- */
  $$('[data-caps]').forEach(function (wrap) {
    var v = $('video', wrap), cap = $('.k-phone__cap', wrap); if (!v || !cap) return;
    var caps; try { caps = JSON.parse(wrap.getAttribute('data-caps')); } catch (_) { return; }
    var last = -1;
    v.addEventListener('timeupdate', function () {
      var t = v.currentTime, idx = -1;
      for (var i = 0; i < caps.length; i++) if (t >= caps[i][0]) idx = i;
      if (idx !== last) { last = idx; cap.style.opacity = 0; setTimeout(function () { cap.innerHTML = idx >= 0 ? caps[idx][1] : ''; cap.style.opacity = 1; }, 180); }
    });
  });

  /* ---------- 7. Kolory płomienia ---------- */
  $$('[data-colors]').forEach(function (sec) {
    var stage = $('.k-colorstage', sec), img = $('img', stage), vid = $('video', stage);
    $$('.k-swatch', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.k-swatch', sec).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        stage.style.setProperty('--glow', b.getAttribute('data-glow'));
        var t = parseFloat(b.getAttribute('data-t'));
        if (vid && !isNaN(t)) { try { vid.currentTime = t; vid.play(); } catch (_) {} }
      });
    });
  });

  /* ---------- 8. Galeria produktu ---------- */
  $$('[data-gal]').forEach(function (g) {
    var slides = $$('.k-gal__slide', g), thumbs = $$('.k-gal__thumb', g), burn = $('.k-gal__burn', g), i = 0, timer;
    if (slides.length < 2) return;
    function go(n, user) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        var v = $('video', s); if (v) { if (k === i) { var p = v.play(); p && p.catch && p.catch(function () {}); } else v.pause(); }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (burn && !RM) { burn.style.setProperty('--bx', (20 + Math.random() * 60) + '%'); burn.classList.remove('go'); void burn.offsetWidth; burn.classList.add('go'); }
      if (user) { clearInterval(timer); }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k, true); }); });
    var p = $('.k-gal__nav--p', g), n = $('.k-gal__nav--n', g);
    p && p.addEventListener('click', function () { go(i - 1, true); });
    n && n.addEventListener('click', function () { go(i + 1, true); });
    var sx = null, st = $('.k-gal__stage', g);
    st.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    st.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1), true); sx = null; });
    if (!RM) timer = setInterval(function () { go(i + 1); }, 6000);
  });

  /* ---------- 9. Koszyk / Kup teraz / Paczkomat ---------- */
  function cartCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }

  // Mapa Paczkomatów
  var LJS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.js';
  var LCSS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.css';
  var API = 'https://api-pl-points.easypack24.net/v1/points';
  var modal = $('#KPkModal'), map, layer, active, lastKey = '', reqId = 0, mt;
  function addrOf(p) { var a = p.address || {}; return [a.line1, a.line2].filter(Boolean).join(', '); }
  function status(t) { if (modal) $('[data-pkm-status]', modal).textContent = t; }
  function loadLeaflet() {
    if (window.L) return Promise.resolve();
    return new Promise(function (res, rej) {
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = LCSS; document.head.appendChild(l);
      var s = document.createElement('script'); s.src = LJS; s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
  }
  function openModal() {
    if (!modal) return;
    modal.hidden = false; document.documentElement.style.overflow = 'hidden';
    loadLeaflet().then(function () {
      if (!map) {
        map = L.map($('[data-pkm-map]', modal)).setView([52.07, 19.48], 6);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, subdomains: 'abc', attribution: '&copy; OpenStreetMap' }).addTo(map);
        layer = L.layerGroup().addTo(map);
        map.on('moveend', function () { clearTimeout(mt); mt = setTimeout(loadPoints, 250); });
      }
      setTimeout(function () { map.invalidateSize(); }, 80);
    }).catch(function () { status('Mapa się nie wczytała – wpisz kod Paczkomatu ręcznie.'); });
    setTimeout(function () { var q = $('[data-pkm-q]', modal); q && q.focus({ preventScroll: true }); }, 60);
  }
  function closeModal() { if (!modal) return; modal.hidden = true; document.documentElement.style.overflow = ''; }
  function loadPoints() {
    if (!map) return;
    var list = $('[data-pkm-list]', modal);
    if (map.getZoom() < 12) { layer.clearLayers(); list.innerHTML = ''; status('Wpisz miasto lub kliknij „Blisko mnie”, żeby zobaczyć Paczkomaty.'); return; }
    var c = map.getCenter(), b = map.getBounds();
    var r = Math.min(10000, Math.max(800, Math.round(c.distanceTo(b.getNorthEast()))));
    var key = c.lat.toFixed(3) + ',' + c.lng.toFixed(3) + ',' + r; if (key === lastKey) return; lastKey = key;
    var my = ++reqId; status('Szukam Paczkomatów…');
    fetch(API + '?relative_point=' + c.lat.toFixed(5) + ',' + c.lng.toFixed(5) + '&max_distance=' + r + '&sort_by=distance_to_relative_point&type=parcel_locker&per_page=120&fields=name,location,address,location_description,status')
      .then(function (x) { if (!x.ok) throw 0; return x.json(); })
      .then(function (d) {
        if (my !== reqId) return;
        var items = (d.items || []).filter(function (p) { return p.name && p.location && p.name.indexOf('POP-') !== 0 && (!p.status || p.status === 'Operating'); });
        layer.clearLayers();
        if (!items.length) { list.innerHTML = ''; status('Brak Paczkomatów w tym miejscu – przesuń lub oddal mapę.'); return; }
        status('Znaleziono ' + items.length + ' – kliknij, żeby wybrać.');
        list.innerHTML = items.slice(0, 50).map(function (p, i) { return '<li><button type="button" data-i="' + i + '"><strong>' + esc(p.name) + '</strong>' + esc(addrOf(p)) + (p.location_description ? ' · ' + esc(p.location_description) : '') + '</button></li>'; }).join('');
        items.forEach(function (p) {
          L.circleMarker([p.location.latitude, p.location.longitude], { radius: 9, color: '#2a1204', weight: 2, fillColor: '#ffb35c', fillOpacity: 1 })
            .addTo(layer).on('click', function () { choose(p); });
        });
        $$('button', list).forEach(function (bt) { bt.addEventListener('click', function () { choose(items[+bt.getAttribute('data-i')]); }); });
      })
      .catch(function () { if (my === reqId) { status('Nie udało się pobrać Paczkomatów. Wpisz kod ręcznie.'); lastKey = ''; } });
  }
  function choose(p) { if (active) active(p.name, addrOf(p)); closeModal(); }
  if (modal) {
    $$('[data-pkm-close]', modal).forEach(function (b) { b.addEventListener('click', closeModal); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    $('[data-pkm-search]', modal).addEventListener('submit', function (e) {
      e.preventDefault(); var q = $('[data-pkm-q]', modal).value.trim(); if (!q) return;
      if (/^[A-Za-z]{3}\d{2,3}[A-Za-z]{0,3}$/.test(q) && active) { active(q.toUpperCase(), ''); closeModal(); return; }
      status('Szukam…');
      fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=pl&accept-language=pl&q=' + encodeURIComponent(q))
        .then(function (r) { return r.json(); })
        .then(function (d) { if (!d || !d[0]) { status('Nie znaleziono – spróbuj inaczej.'); return; } map && map.setView([+d[0].lat, +d[0].lon], 15); })
        .catch(function () { status('Nie udało się wyszukać.'); });
    });
    $('[data-pkm-near]', modal).addEventListener('click', function () {
      if (!navigator.geolocation) return;
      status('Ustalam lokalizację…');
      navigator.geolocation.getCurrentPosition(function (p) { map && map.setView([p.coords.latitude, p.coords.longitude], 15); },
        function () { status('Brak dostępu do lokalizacji – wpisz miasto lub ulicę.'); }, { enableHighAccuracy: true, timeout: 10000 });
    });
  }

  $$('[data-product-form]').forEach(function (form) {
    var preview = form.hasAttribute('data-preview');
    var qty = $('input[name="quantity"]', form);
    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, Math.min(99, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10))); });
    });
    // Paczkomat
    var pk = $('[data-pk]', form), code = $('[data-pk-code]', form), addr = $('[data-pk-addr]', form), err = $('[data-pk-err]', form), chosen = $('[data-pk-chosen]', form), wrap = $('[data-pk-wrap]', form);
    function method() { var c = $('[data-pk-method]:checked', form); return c ? c.value : ''; }
    function sync() { if (!pk) return; var on = method() === 'Paczkomat InPost'; wrap.hidden = !on; code.disabled = !on; addr.disabled = !on || !addr.value; if (!on) { err.hidden = true; code.classList.remove('is-error'); } }
    function showChosen() {
      var v = code.value.trim();
      if (v) { chosen.innerHTML = '✓ <strong>' + esc(v) + '</strong>' + (addr.value ? ' · ' + esc(addr.value) : '') + '<small>W kasie wybierz „Paczkomat InPost – 0 zł”.</small>'; chosen.hidden = false; $('[data-pk-open-label]', form).textContent = 'Zmień Paczkomat'; }
      else { chosen.hidden = true; $('[data-pk-open-label]', form).textContent = 'Wybierz Paczkomat na mapie'; }
    }
    function valid() {
      if (!pk || method() !== 'Paczkomat InPost' || code.value.trim().length >= 4) return true;
      err.hidden = false; code.classList.add('is-error'); pk.scrollIntoView({ behavior: 'smooth', block: 'center' }); return false;
    }
    if (pk) {
      $$('[data-pk-method]', form).forEach(function (r) { r.addEventListener('change', sync); });
      $('[data-pk-open]', form).addEventListener('click', function () {
        active = function (n, a) { code.value = n; addr.value = a || ''; addr.disabled = !a; err.hidden = true; code.classList.remove('is-error'); showChosen(); };
        openModal();
      });
      var mb = $('[data-pk-manual]', form), mbox = $('[data-pk-manualbox]', form);
      mb.addEventListener('click', function () { mbox.hidden = false; mb.hidden = true; code.focus(); });
      code.addEventListener('input', function () { var v = code.value.toUpperCase().replace(/[^A-Z0-9-]/g, ''); if (v !== code.value) code.value = v; addr.value = ''; addr.disabled = true; showChosen(); if (v.length >= 4) { err.hidden = true; code.classList.remove('is-error'); } });
      sync();
    }
    var fe = $('[data-form-error]', form);
    function add() {
      return fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Błąd'); return j; }); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (preview) { toast('Podgląd szablonu – produkt jest jeszcze <b>wersją roboczą</b>. Ustaw go jako Aktywny w Shopify, a koszyk zacznie działać.'); return; }
      if (!valid()) return;
      var btn = $('[data-add]', form), lbl = btn.innerHTML; btn.disabled = true; btn.innerHTML = 'Dodaję…';
      add().then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (c) { cartCount(c.item_count); toast('🔥 Dodano do koszyka · <a href="' + (K.cart || '/cart') + '">Zobacz koszyk</a>'); })
        .catch(function (x) { if (fe) { fe.textContent = x.message || 'Nie udało się dodać do koszyka.'; fe.hidden = false; } })
        .then(function () { btn.disabled = false; btn.innerHTML = lbl; });
    });
    var bn = $('[data-buy-now]', form);
    bn && bn.addEventListener('click', function () {
      if (preview) { toast('Podgląd szablonu – „Kup teraz” zadziała, gdy produkt będzie Aktywny.'); return; }
      if (!valid()) return;
      var lbl = bn.innerHTML; bn.disabled = true; bn.innerHTML = 'Przechodzę do kasy…';
      add().then(function () { location.href = '/checkout'; })
        .catch(function (x) { bn.disabled = false; bn.innerHTML = lbl; if (fe) { fe.textContent = x.message || 'Nie udało się przejść do kasy.'; fe.hidden = false; } });
    });
  });

  // Przyklejony pasek zakupu
  var sticky = $('[data-sticky]'), buy = $('[data-buybox]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    var seen = false;
    new IntersectionObserver(function (e) { var r = e[0]; seen = seen || r.isIntersecting; sticky.classList.toggle('is-on', !r.isIntersecting && r.boundingClientRect.top < 0); }).observe(buy);
    $('button', sticky).addEventListener('click', function () { buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  }
  // Linki "kup" przewijają do koszyka na stronie z produktem
  $$('a[href="#kup"]').forEach(function (a) { a.setAttribute('data-no-curtain', ''); });

  /* ---------- 10. Szacowana data dostawy ---------- */
  $$('[data-eta]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 3, max = parseInt(el.getAttribute('data-max'), 10) || 6;
    function addWork(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var f = function (d) { return d.toLocaleDateString('pl-PL', { weekday: 'short', day: 'numeric', month: 'long' }); };
    var now = new Date(); el.textContent = f(addWork(now, min)) + ' – ' + f(addWork(now, max));
  });

  /* ---------- 11. Cookies (Shopify Customer Privacy API) ---------- */
  var cb = $('#KCookies');
  function cookieDecided() { try { return localStorage.getItem('k-cookies'); } catch (_) { return null; } }
  function setConsent(all) {
    try { localStorage.setItem('k-cookies', all ? 'all' : 'needed'); } catch (_) {}
    if (window.Shopify && Shopify.customerPrivacy) Shopify.customerPrivacy.setTrackingConsent({ analytics: all, marketing: all, preferences: all, sale_of_data: all }, function () {});
    cb.hidden = true;
  }
  if (cb) {
    if (!cookieDecided()) {
      if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      setTimeout(function () { cb.hidden = false; }, 1500);
    }
    $('[data-ck-all]', cb).addEventListener('click', function () { setConsent(true); });
    $('[data-ck-needed]', cb).addEventListener('click', function () { setConsent(false); });
    $$('[data-cookie-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); cb.hidden = false; }); });
  }
})();
